
import { getCurrentConference } from '../base/conference';
import { getVisitorsCount } from '../visitors/functions';

/**
* Selector to return lobby enable state.
*
* @param {Object} state - State object.
* @returns {boolean}
*/
export function getLobbyEnabled(state: Object) {
    return state['features/lobby'].lobbyEnabled;
}

/**
* Selector to return a list of knocking participants.
*
* @param {Object} state - State object.
* @returns {Array<Object>}
*/
export function getKnockingParticipants(state: Object) {
    return state['features/lobby'].knockingParticipants;
}

/**
 * Approves (lets in) or rejects a knocking participant.
 *
 * @param {Function} getState - Function to get the Redux state.
 * @param {string} id - The id of the knocking participant.
 * @param {boolean} approved - True if the participant is approved, false otherwise.
 * @returns {Function}
 */
export function setKnockingParticipantApproval(getState: Function, id: string, approved: boolean) {
    const conference = getCurrentConference(getState());

    if (conference) {
        if (approved) {
            conference.lobbyApproveAccess(id);
        } else {
            conference.lobbyDenyAccess(id);
        }
    }
}

/**
 * Selector to return lobby state.
 *
 * @param {any} state - State object.
 * @returns {any}
 */
export function getLobbyState(state: any) {
    return state['features/lobby'];
}

/**
 * Selector to return lobby visibility.
 *
 * @param {IReduxState} state - State object.
 * @returns {any}
 */
export function getIsLobbyVisible(state: any) {
    return state['features/lobby'].lobbyVisible;
}

/**
 * Checks if lobby mode toggling is currently loading.
 * Replaces the old 5-second rate-limiting restriction with a check on the active
 * 2-3 second loader state so users can toggle frequently once the loader finishes.
 *
 * @param {Function} dispatch - Redux dispatch function.
 * @param {Object} [state] - Optional Redux state object.
 * @returns {boolean} - True if currently loading, false otherwise.
 */
export function checkLobbyRateLimit(dispatch: Function, state?: Object): boolean {
    if (state && state['features/lobby']?.lobbyLoading) {
        return true;
    }

    if (typeof dispatch === 'function') {
        let isLoading = false;

        try {
            dispatch((_, getState) => {
                const s = typeof getState === 'function' ? getState() : undefined;

                if (s && s['features/lobby']?.lobbyLoading) {
                    isLoading = true;
                }
            });
        } catch (e) {
            // ignore
        }

        if (isLoading) {
            return true;
        }
    }

    return false;
}

/**
 * Returns true if enabling lobby is allowed and false otherwise.
 *
 * @param {IReduxState} state - State object.
 * @returns {boolean}
 */
export function isEnablingLobbyAllowed(state) {
    return getVisitorsCount(state) <= 0;
}


